import { useState, PureComponent } from 'react'
import styles from './TextInputTag.css'
import cx from 'classnames'
import _ from 'lodash'

export const ENTER_KEY = 13
export const COMMA_KEY = 188
const TAG_INPUT_PLACEHOLDER = '輸入單筆或多筆項目，以逗號或 ENTER 分隔'

const WHITESPACE_REGEX = /\s*/g
const COMMA_REGEX = /,/g

export const TextTagInputField = props => {
  const [value, setValue] = useState('')
  const { onSubmitTag, placeholder } = props

  const addTags = tags => {
    onSubmitTag(tags)
    setValue('')
  }

  const handleTextInputKeyDown = e => {
    const { keyCode } = e
    if ((keyCode === ENTER_KEY || keyCode === COMMA_KEY) && value !== '') {
      addTags([value])
    }
  }

  const handleTextInputChange = e => {
    const value = _.get(e, 'target.value', '')
    if (value === ',') { return }

    const sanitizedValue = value.replace(WHITESPACE_REGEX, '')
    const splittedValue = sanitizedValue.split(COMMA_REGEX)
    if (splittedValue.length > 1) {
      // 有包含到逗號
      addTags(splittedValue)
    } else {
      setValue(sanitizedValue)
    }
  }

  return (
    <input
      type='text'
      value={value}
      placeholder={placeholder}
      className={styles.tagInput}
      onChange={handleTextInputChange}
      onKeyDown={handleTextInputKeyDown}
    />
  )
}

const TagsListItem = props => {
  const { className, children, ...otherProps } = props

  const clz = cx(styles.tagsListItem, className)

  return (
    <li
      className={clz}
      {...otherProps}
    >
      {children}
    </li>
  )
}

const TagsList = props => {
  const { tags, addonAfter } = props
  const listItems = tags.map((tag, i) => (
    <TagsListItem key={tag + i}>{tag}</TagsListItem>
  ))

  return (
    <ul
      className={styles.tagsList}
      data-role='tags-list'
    >
      {listItems}
      <TagsListItem
        className={styles.lastTagsListItem}
        key='last-item'
      >
        {addonAfter}
      </TagsListItem>
    </ul>
  )
}

// Final Component
class TextInputTag extends PureComponent {
  render () {
    const {
      disabled = false,
      showTextTagInputField = true,
      selectedTags = [],
      onSubmitTag
    } = this.props
    const AddonAfter = disabled || !showTextTagInputField
      ? null
      : (
        <TextTagInputField
          placeholder={TAG_INPUT_PLACEHOLDER}
          onSubmitTag={onSubmitTag}
        />
      )
    return (
      <div
        data-role='text-input-tag'
        className={cx(styles.textInputTag, { disabled })}
      >
        <TagsList
          tags={selectedTags}
          addonAfter={AddonAfter}
        />
      </div>
    )
  }
}

export default TextInputTag
